// ChatResponsiveDesignLayout.jsx
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Outlet, useParams, useLocation } from 'react-router';
import UniversalContainer from '../component/UniversalContainer.jsx';
import { DESKTOP_TOP_MARGIN_OFFSET } from '../resource/chatroomConstants.js';

const ChatResponsiveDesignLayout = ({ deviceHeight, isOnDesktop }) => {
  const { chatroomId } = useParams();
  const { pathname } = useLocation();

  return isOnDesktop ? (
    <>
      <ChatListWrapper>
        <ChatroomsWrapper>
          <UniversalContainer filename="Chatrooms" activeId={chatroomId} />
        </ChatroomsWrapper>

        <OutletWrapper
          deviceHeight={deviceHeight}
          isOnDefaultPage={pathname === '/chat'}
        >
          <Outlet />
        </OutletWrapper>
      </ChatListWrapper>
    </>
  ) : (
    <Outlet />
  );
};

ChatResponsiveDesignLayout.propTypes = {
  deviceHeight: PropTypes.number,
  isOnDesktop: PropTypes.bool,
};

ChatResponsiveDesignLayout.defaultProps = {
  deviceHeight: 0,
  isOnDesktop: false,
};

const ChatListWrapper = styled.div`
  margin-top: ${DESKTOP_TOP_MARGIN_OFFSET}px;
  display: flex;
`;

const ChatroomsWrapper = styled.div`
  min-width: 360px;
  width: 360px;
`;

const OutletWrapper = styled.main`
  height: ${({ deviceHeight }) =>
    `${deviceHeight - DESKTOP_TOP_MARGIN_OFFSET}px`};
  overflow-x: auto;
  padding-top: ${({ isOnDefaultPage }) => (isOnDefaultPage ? '40px' : '0')};
  flex-grow: 1;
  border-left: 1px solid rgba(100, 100, 100, 0.15);
`;

export default ChatResponsiveDesignLayout;
